// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICountryInfoDto
 */
export interface ICountryInfoDto {
    /**
     * 
     * @type {number}
     * @memberof ICountryInfoDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICountryInfoDto
     */
    us_postal?: string;
    /**
     * 
     * @type {string}
     * @memberof ICountryInfoDto
     */
    alpha2?: string;
    /**
     * 
     * @type {string}
     * @memberof ICountryInfoDto
     */
    alpha3?: string;
    /**
     * 
     * @type {string}
     * @memberof ICountryInfoDto
     */
    name?: string;
}

/**
 * Check if a given object implements the ICountryInfoDto interface.
 */
export function instanceOfICountryInfoDto(value: object): value is ICountryInfoDto {
    return true;
}

export function ICountryInfoDtoFromJSON(json: any): ICountryInfoDto {
    return ICountryInfoDtoFromJSONTyped(json, false);
}

export function ICountryInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICountryInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'us_postal': json['us_postal'] == null ? undefined : json['us_postal'],
        'alpha2': json['alpha2'] == null ? undefined : json['alpha2'],
        'alpha3': json['alpha3'] == null ? undefined : json['alpha3'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function ICountryInfoDtoToJSON(json: any): ICountryInfoDto {
    return ICountryInfoDtoToJSONTyped(json, false);
}

export function ICountryInfoDtoToJSONTyped(value?: ICountryInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'us_postal': value['us_postal'],
        'alpha2': value['alpha2'],
        'alpha3': value['alpha3'],
        'name': value['name'],
    };
}

